import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dossier",
  "use": "dossier-usage",
  "viewBox": "0 0 37 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 37\" id=\"dossier\"><path d=\"M27.75 6.438v1l1.813-.001v24.437H9.75v-1.811h-1v2.812h21.813V6.437z\" /><path d=\"M13.979 4.125H28.25v26.438H6.437v-18.92l7.542-7.519zm.413 1l-6.954 6.934v17.503H27.25V5.125H14.391z\" /><path d=\"M14.632 4.855l-.257 7.207H6.937l.257-1h6.181l.257-6.207zm9.649 13.641v1H10.406v-1zm0-3.469v1H10.406v-1zm0 6.937v1H10.406v-1zm0 3.469v1H10.406v-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol